// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
// Shared Imports
import { ELocalStorageKeys } from '@shared/models'
// Store Imports
import { Store } from '@ngrx/store'
import { SIGNIN, SIGNOUT } from '@store/actions'

export const isLoggedGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const _router = inject(Router)
	const _store = inject(Store)

	// We get the tokens from the local storage
	const accessToken = window.localStorage.getItem(ELocalStorageKeys.accessToken)
	const refreshToken = window.localStorage.getItem(ELocalStorageKeys.refreshToken)

	if (accessToken && refreshToken) {
		_store.dispatch(SIGNIN({ accessToken, refreshToken }))
		return true
	} else {
		_store.dispatch(SIGNOUT())
		_router.navigate(['/login'])
		return false
	}
}
